import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const PaywallGroupsSettingsComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "PaywallGroupsSettingsPage" */ "@circle-react/components/SettingsApp/PaywallGroups"
    ),
);

export const PaywallGroupsSettingsPage = () => (
  <Suspense fallback={<PageLoader />}>
    <PaywallGroupsSettingsComponent />
  </Suspense>
);
